<template>
  <v-col cols="12" md="6" class="p-success-payment_middle_left">
    <span class="heading-5 p-success-payment_middle_left_title mb-3">{{ $t("visits.payment.details") }}</span>
    <div>
      <span class="p-success-payment_middle_left_pre-text">{{ $t("visits.payment.payDate") }}: </span>
      <span>{{ paymentDate }}</span>
    </div>
    <div>
      <span class="p-success-payment_middle_left_pre-text">{{ $t("visits.payment.payer") }}: </span>
      <span>{{ email }}</span>
    </div>
    <div>
      <span class="p-success-payment_middle_left_pre-text">{{ $t("visits.payment.totalSum") }}: </span>
      <span class="p-success-payment_middle_left_green-text">{{ price }}</span>
    </div>
  </v-col>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  props: ["paymentDate", "email", "price"],
  name: "SuccessPaymentPaymentDetails",
});
</script>
